export default {
    title: 'Aktivitäten',
    noActivities: 'Noch keine Aktivitäten',
    noChanges: 'Keine Änderungen',
    changes: 'Änderungen'
}
